import React from 'react';
import { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import Head from '../../components/head';
import FormLogin from '../../components/loginfunc'
import '../../styles/login.scss'


function HomeScreen () {
    return (
        <Fragment>
            <Head titulo="Acesso RH Holerite" />
            <div className='bg-login'>
            <Row className="justify-content-md-center">
                <Col lg={4}>
                    <FormLogin />
                </Col>
            </Row>
            </div>
        </Fragment>
    );
}

export default HomeScreen;